<template>
  <v-app>
    <svg
      version="1.1"
      id="home-anim"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      style="position: absolute; top: 0; opacity: 0.6;"
      xml:space="preserve"
    >
      <defs>
        <!-- <rect id="masque" y="0.4" width="100%" height="100%" />-->
        <pattern
          id="polka-dots"
          x="0"
          y="0"
          width="100%"
          height="100%"
          patternUnits="userSpaceOnUse"
        >
          <g id="animated-lines">
            <line x1="-134.7" y1="674.9" x2="19.8" y2="520.4" />
            <line x1="74" y1="309.2" x2="-80.5" y2="463.7" />
            <line x1="301.4" y1="238.8" x2="455.9" y2="84.3" />
            <line x1="510.1" y1="-126.9" x2="355.6" y2="27.6" />
            <line x1="-88.6" y1="1008.9" x2="65.9" y2="854.4" />
            <line x1="120.1" y1="643.1" x2="-34.4" y2="797.7" />
            <line x1="347.5" y1="572.8" x2="502" y2="418.3" />
            <line x1="556.2" y1="207.1" x2="401.7" y2="361.6" />
            <line x1="783.6" y1="136.7" x2="938.1" y2="-17.8" />
            <line x1="-51.2" y1="1351.6" x2="103.3" y2="1197" />
            <line x1="157.6" y1="985.8" x2="3" y2="1140.3" />
            <line x1="384.9" y1="915.5" x2="539.4" y2="760.9" />
            <line x1="593.6" y1="549.7" x2="439.1" y2="704.3" />
            <line x1="821" y1="479.4" x2="975.5" y2="324.9" />
            <line x1="1029.7" y1="113.6" x2="875.2" y2="268.2" />
            <line x1="1257.1" y1="43.3" x2="1411.6" y2="-111.2" />
            <line x1="-14" y1="1696.1" x2="140.5" y2="1541.6" />
            <line x1="194.7" y1="1330.4" x2="40.2" y2="1484.9" />
            <line x1="422.1" y1="1260" x2="576.6" y2="1105.5" />
            <line x1="630.8" y1="894.3" x2="476.3" y2="1048.8" />
            <line x1="858.2" y1="823.9" x2="1012.7" y2="669.4" />
            <line x1="1066.9" y1="458.2" x2="912.4" y2="612.7" />
            <line x1="1294.3" y1="387.8" x2="1448.8" y2="233.3" />
            <line x1="1503" y1="22.1" x2="1348.5" y2="176.6" />
            <line x1="23.4" y1="2038.8" x2="177.9" y2="1884.3" />
            <line x1="232.1" y1="1673.1" x2="77.6" y2="1827.6" />
            <line x1="459.5" y1="1602.7" x2="614" y2="1448.2" />
            <line x1="668.2" y1="1237" x2="513.7" y2="1391.5" />
            <line x1="895.6" y1="1166.6" x2="1050.1" y2="1012.1" />
            <line x1="1104.3" y1="800.9" x2="949.8" y2="955.4" />
            <line x1="1331.7" y1="730.5" x2="1486.2" y2="576" />
            <line x1="1540.4" y1="364.8" x2="1385.9" y2="519.3" />
            <line x1="1767.8" y1="294.4" x2="1922.3" y2="139.9" />
            <line x1="1976.5" y1="-71.3" x2="1822" y2="83.2" />
            <line x1="60.8" y1="2381.5" x2="215.3" y2="2227.0" />
            <line x1="269.5" y1="2015.8" x2="115.0" y2="2170.3" />
            <line x1="496.9" y1="1945.4" x2="651.4" y2="1790.9" />
            <line x1="705.6" y1="1579.7" x2="551.1" y2="1734.2" />
            <line x1="933" y1="1509.3" x2="1087.5" y2="1354.8" />
            <line x1="1141.7" y1="1143.6" x2="987.2" y2="1298.1" />
            <line x1="1369.1" y1="1073.2" x2="1523.6" y2="918.7" />
            <line x1="1577.8" y1="707.5" x2="1423.3" y2="862" />
            <line x1="1805.2" y1="637.1" x2="1959.7" y2="482.6" />
            <line x1="2013.9" y1="271.4" x2="1859.4" y2="425.9" />

            <line x1="107.0" y1="2715.4" x2="261.4" y2="2560.9" />
            <line x1="315.7" y1="2349.7" x2="161.1" y2="2504.2" />
            <line x1="543.1" y1="2279.3" x2="697.5" y2="2124.8" />
            <line x1="751.8" y1="1913.6" x2="597.2" y2="2068.1" />
            <line x1="979.2" y1="1843.2" x2="1133.6" y2="1688.7" />
            <line x1="1187.9" y1="1477.5" x2="1033.3" y2="1632.0" />
            <line x1="1415.3" y1="1407.1" x2="1569.7" y2="1252.6" />
            <line x1="1624" y1="1041.4" x2="1469.4" y2="1195.9" />
            <line x1="1851.4" y1="971" x2="2005.8" y2="816.5" />
            <line x1="2060.1" y1="605.3" x2="1905.5" y2="759.8" />
            <line x1="153.1" y1="3049.3" x2="307.5" y2="2894.8" />
            <line x1="361.8" y1="2683.6" x2="207.2" y2="2838.1" />
            <line x1="589.2" y1="2613.2" x2="743.6" y2="2458.7" />
            <line x1="797.9" y1="2247.5" x2="643.3" y2="2402.0" />
            <line x1="1025.3" y1="2177.1" x2="1179.7" y2="2022.6" />
            <line x1="1234.0" y1="1811.4" x2="1079.4" y2="1965.9" />
            <line x1="1461.4" y1="1741.0" x2="1615.8" y2="1586.5" />
            <line x1="1670.1" y1="1375.3" x2="1515.5" y2="1529.8" />
            <line x1="1897.5" y1="1304.9" x2="2051.9" y2="1150.4" />
            <line x1="199.2" y1="3383.2" x2="353.6" y2="3228.7" />
            <line x1="407.9" y1="3017.5" x2="253.3" y2="3172" />
            <line x1="635.3" y1="2947.1" x2="789.7" y2="2792.6" />
            <line x1="844.0" y1="2581.4" x2="689.4" y2="2735.9" />
            <line x1="1071.4" y1="2511.0" x2="1225.8" y2="2356.5" />
            <line x1="1280.1" y1="2145.3" x2="1125.5" y2="2299.8" />
            <line x1="1507.5" y1="2074.9" x2="1661.9" y2="1920.4" />
            <line x1="1716.2" y1="1709.2" x2="1561.6" y2="1863.7" />
            <line x1="17.9" y1="3787.5" x2="-136.7" y2="3942.0" />
            <line x1="245.3" y1="3717.1" x2="399.7" y2="3562.6" />
            <line x1="454" y1="3351.4" x2="299.4" y2="3505.9" />
            <line x1="681.4" y1="3281.0" x2="835.8" y2="3126.5" />
            <line x1="890.1" y1="2915.3" x2="735.5" y2="3069.8" />
            <line x1="1117.5" y1="2844.9" x2="1271.9" y2="2690.4" />
            <line x1="1326.2" y1="2479.2" x2="1171.6" y2="2633.7" />
            <line x1="1553.6" y1="2408.8" x2="1708.0" y2="2254.3" />
            <line x1="1762.3" y1="2043.1" x2="1607.7" y2="2197.6" />
            <line x1="64" y1="4121.4" x2="-90.6" y2="4275.9" />
            <line x1="291.4" y1="4051" x2="445.8" y2="3896.5" />
            <line x1="500.1" y1="3685.3" x2="345.5" y2="3839.8" />
            <line x1="727.5" y1="3614.9" x2="881.9" y2="3460.4" />
            <line x1="936.2" y1="3249.2" x2="781.6" y2="3403.7" />
            <line x1="1163.6" y1="3178.8" x2="1318.0" y2="3024.3" />
            <line x1="1372.3" y1="2813.1" x2="1217.7" y2="2967.6" />
            <line x1="1599.7" y1="2742.7" x2="1754.1" y2="2588.2" />
            <line x1="1808.4" y1="2377.0" x2="1653.8" y2="2531.5" />
            <line x1="110.1" y1="4455.3" x2="-44.5" y2="4609.8" />
            <line x1="337.5" y1="4384.9" x2="491.9" y2="4230.4" />
            <line x1="546.2" y1="4019.2" x2="391.6" y2="4173.7" />
            <line x1="773.6" y1="3948.8" x2="928.0" y2="3794.3" />
            <line x1="982.3" y1="3583.1" x2="827.7" y2="3737.6" />
            <line x1="1209.7" y1="3512.7" x2="1364.1" y2="3358.2" />
            <line x1="1418.4" y1="3147.0" x2="1263.8" y2="3301.5" />
            <line x1="1645.8" y1="3076.6" x2="1800.2" y2="2922.1" />
            <line x1="1854.5" y1="2710.9" x2="1699.9" y2="2865.4" />
            <line x1="383.6" y1="4718.8" x2="538" y2="4564.3" />
            <line x1="592.3" y1="4353.1" x2="437.7" y2="4507.6" />
            <line x1="819.7" y1="4282.7" x2="974.1" y2="4128.2" />
            <line x1="1028.4" y1="3917.0" x2="873.8" y2="4071.5" />
            <line x1="1255.8" y1="3846.6" x2="1410.2" y2="3692.1" />
            <line x1="1464.5" y1="3480.9" x2="1309.9" y2="3635.4" />
            <line x1="1691.9" y1="3410.5" x2="1846.3" y2="3256.0" />
            <line x1="1900.6" y1="3044.8" x2="1746.0" y2="3199.3" />
            <line x1="638.4" y1="4687.0" x2="483.8" y2="4841.5" />
            <line x1="865.8" y1="4616.6" x2="1020.2" y2="4462.1" />
            <line x1="1074.5" y1="4250.9" x2="919.9" y2="4405.4" />
            <line x1="1301.9" y1="4180.5" x2="1456.3" y2="4026.0" />
            <line x1="1510.6" y1="3814.8" x2="1356.0" y2="3969.3" />
            <line x1="1738.0" y1="3744.4" x2="1892.4" y2="3589.9" />
            <line x1="1946.7" y1="3378.7" x2="1792.1" y2="3533.2" />
            <line x1="911.9" y1="4950.5" x2="1066.3" y2="4796.0" />
            <line x1="1120.6" y1="4584.8" x2="966.0" y2="4739.3" />
            <line x1="1348.0" y1="4514.4" x2="1502.4" y2="4359.9" />
            <line x1="1556.7" y1="4148.7" x2="1402.1" y2="4303.2" />
            <line x1="1784.1" y1="4078.3" x2="1938.5" y2="3923.8" />
            <line x1="1992.8" y1="3712.6" x2="1838.2" y2="3867.1" />
            <line x1="1166.7" y1="4918.7" x2="1012.1" y2="5073.2" />
            <line x1="1394.1" y1="4848.3" x2="1548.5" y2="4693.8" />
            <line x1="1602.8" y1="4482.6" x2="1448.2" y2="4637.1" />
            <line x1="1830.2" y1="4412.2" x2="1984.6" y2="4257.7" />
          </g>
          <g id="static-lines">
            <line x1="794.4" y1="883.4" x2="639.8" y2="1037.9" stroke-dasharray="3"/>
            <line x1="694.6" y1="834.8" x2="849.2" y2="680.3" stroke-dasharray="3"/>
            <line x1="1230.4" y1="447.3" x2="1075.9" y2="601.8" stroke-dasharray="3"/>
            <line x1="1130.7" y1="398.7" x2="1285.2" y2="244.2" stroke-dasharray="3"/>
            <line x1="1666.5" y1="11.2" x2="1512" y2="165.7" stroke-dasharray="3"/>
            <line x1="732" y1="1177.5" x2="886.6" y2="1023" stroke-dasharray="3"/>
            <line x1="1267.9" y1="790" x2="1113.3" y2="944.5" stroke-dasharray="3"/>
            <line x1="1168.1" y1="741.4" x2="1322.7" y2="586.9" stroke-dasharray="3"/>
            <line x1="1703.9" y1="353.9" x2="1549.4" y2="508.4" stroke-dasharray="3"/>
            <line x1="1604.2" y1="305.3" x2="1758.7" y2="150.8" stroke-dasharray="3"/>
            <line x1="1205.5" y1="1084.1" x2="1360.1" y2="929.6" stroke-dasharray="3"/>
            <line x1="1741.4" y1="696.5" x2="1586.8" y2="851.1" stroke-dasharray="3"/>
            <line x1="1641.6" y1="648" x2="1796.2" y2="493.5" stroke-dasharray="3"/>
            <line x1="1787.5" y1="1030.5" x2="1633" y2="1185" stroke-dasharray="3"/>
            <line x1="1687.8" y1="981.9" x2="1842.3" y2="827.4" stroke-dasharray="3"/>
            <line x1="1734" y1="1315.8" x2="1888.4" y2="1161.3" stroke-dasharray="3"/>
            <line x1="200.1" y1="-44.4" x2="45.6" y2="110.1" stroke-dasharray="3"/>
            <line x1="237.5" y1="298.3" x2="83" y2="452.8" stroke-dasharray="3"/>
            <line x1="137.8" y1="249.7" x2="292.3" y2="95.2" stroke-dasharray="3"/>
            <line x1="673.6" y1="-137.8" x2="519.1" y2="16.7" stroke-dasharray="3"/>
            <line x1="283.7" y1="632.2" x2="129.2" y2="786.8" stroke-dasharray="3"/>
            <line x1="184" y1="583.7" x2="338.5" y2="429.2" stroke-dasharray="3"/>
            <line x1="719.8" y1="196.2" x2="565.2" y2="350.7" stroke-dasharray="3"/>
            <line x1="620" y1="147.6" x2="774.6" y2="-6.9" stroke-dasharray="3"/>
            <line x1="321.1" y1="974.9" x2="166.6" y2="1129.4" stroke-dasharray="3"/>
            <line x1="221.4" y1="926.4" x2="375.9" y2="771.8" stroke-dasharray="3"/>
            <line x1="757.2" y1="538.8" x2="602.7" y2="693.4" stroke-dasharray="3"/>
            <line x1="657.5" y1="490.3" x2="812" y2="335.8" stroke-dasharray="3"/>
            <line x1="1193.3" y1="102.7" x2="1038.7" y2="257.3" stroke-dasharray="3"/>
            <line x1="1093.5" y1="54.2" x2="1248.1" y2="-100.3" stroke-dasharray="3"/>
          </g>
          <g id="great-static-lines">
            <line x1="232.8" y1="75.5" x2="-76.2" y2="384.6" stroke-dasharray="4 1 2"/>
            <line x1="105.1" y1="129.8" x2="414.2" y2="-179.2" stroke-dasharray="4 1 2"/>
            <line x1="-284.8" y1="899.9" x2="24.2" y2="590.8" stroke-dasharray="4 1 2"/>
            <line x1="270.2" y1="418.2" x2="-38.8" y2="727.3" stroke-dasharray="4 1 2"/>
            <line x1="151.3" y1="463.8" x2="460.3" y2="154.7" stroke-dasharray="4 1 2"/>
            <line x1="706.3" y1="-17.9" x2="397.3" y2="291.2" stroke-dasharray="4 1 2"/>
            <line x1="587.3" y1="27.7" x2="896.4" y2="-281.4" stroke-dasharray="4 1 2"/>
            <line x1="-247.4" y1="1242.5" x2="61.6" y2="933.5" stroke-dasharray="4 1 2"/>
            <line x1="316.4" y1="752.2" x2="7.3" y2="1061.2" stroke-dasharray="4 1 2"/>
            <line x1="188.7" y1="806.4" x2="497.7" y2="497.4" stroke-dasharray="4 1 2"/>
            <line x1="752.5" y1="316.1" x2="443.4" y2="625.1" stroke-dasharray="4 1 2"/>
            <line x1="624.8" y1="370.4" x2="933.8" y2="61.3" stroke-dasharray="4 1 2"/>
            <line x1="1188.6" y1="-120" x2="879.5" y2="189" stroke-dasharray="4 1 2"/>

            <line x1="-210.3" y1="1587.1" x2="98.8" y2="1278.0" stroke-dasharray="4 1 2"/>
            <line x1="353.8" y1="1094.9" x2="44.7" y2="1403.9" stroke-dasharray="4 1 2"/>
            <line x1="225.8" y1="1151" x2="534.9" y2="841.9" stroke-dasharray="4 1 2"/>
            <line x1="789.9" y1="658.8" x2="480.8" y2="967.8" stroke-dasharray="4 1 2"/>
            <line x1="661.9" y1="714.9" x2="971" y2="405.9" stroke-dasharray="4 1 2"/>
            <line x1="1226" y1="222.7" x2="916.9" y2="531.7" stroke-dasharray="4 1 2"/>
            <line x1="1098" y1="278.8" x2="1407.1" y2="-30.2" stroke-dasharray="4 1 2"/>
            <line x1="1662.1" y1="-213.4" x2="1353" y2="95.6" stroke-dasharray="4 1 2"/>

            <line x1="827.1" y1="1003.3" x2="518" y2="1312.3" stroke-dasharray="4 1 2"/>
            <line x1="699.3" y1="1057.6" x2="1008.4" y2="748.5" stroke-dasharray="4 1 2"/>
            <line x1="1263.1" y1="567.2" x2="954.1" y2="876.3" stroke-dasharray="4 1 2"/>
            <line x1="1135.4" y1="621.5" x2="1444.5" y2="312.4" stroke-dasharray="4 1 2"/>
            <line x1="1699.2" y1="131.1" x2="1390.2" y2="440.2" stroke-dasharray="4 1 2"/>
            <line x1="1571.5" y1="185.4" x2="1880.6" y2="-123.6" stroke-dasharray="4 1 2"/>

            <line x1="1300.6" y1="909.9" x2="991.5" y2="1218.9" stroke-dasharray="4 1 2"/>
            <line x1="1172.8" y1="964.2" x2="1481.9" y2="655.1" stroke-dasharray="4 1 2"/>
            <line x1="1736.6" y1="473.8" x2="1427.6" y2="782.8" stroke-dasharray="4 1 2"/>
            <line x1="1608.9" y1="528.1" x2="1918" y2="219" stroke-dasharray="4 1 2"/>

            <line x1="1219" y1="1298.1" x2="1528" y2="989.1" stroke-dasharray="4 1 2"/>
            <line x1="1774.1" y1="816.5" x2="1465" y2="1125.5" stroke-dasharray="4 1 2"/>
            <line x1="1655.1" y1="862" x2="1964.1" y2="553" stroke-dasharray="4 1 2"/>

            <line x1="1701.3" y1="1195.9" x2="2010.2" y2="887" stroke-dasharray="4 1 2"/>
          </g>
        </pattern>
      </defs>
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        fill="url(#polka-dots)"
      ></rect>
    </svg>
    <core-app-bar class="transparent" />
    <core-drawer />
    <v-main class="transparent">
      <router-view />
    </v-main>
    <core-footer class="transparent" />
    <template v-if="message.text">
      <v-snackbar
        :timeout="3000"
        :multi-line="true"
        :color="message.type"
        :value="true"
        @input="closeMessage"
        top
      >
        {{ message.text }}
        <v-btn @click.native="closeMessage" text>
          Закрыть
        </v-btn>
      </v-snackbar>
    </template>
  </v-app>
</template>

<script>
export default {
  created() {
    this.$axios.get("https://fivetu-backend.herokuapp.com/").catch(() => {
      this.$store.dispatch("setMessage", {
        type: "warning",
        text:
          "Отправка сообщений недоступна, попробуйте перезагрузить страницу..."
      });
    });
  },
  components: {
    CoreAppBar: () => import("@/components/core/AppBar"),
    CoreDrawer: () => import("@/components/core/Drawer"),
    CoreFooter: () => import("@/components/core/Footer")
  },
  name: "App",
  computed: {
    message() {
      return this.$store.getters.message;
    }
  },
  methods: {
    closeMessage() {
      this.$store.dispatch("clearMessage");
    }
  }
};
</script>

<style>
#static-lines {
  fill: none;
  opacity: 0.15;
  stroke: #BCAAA4;
  stroke-width: 12;
  stroke-miterlimit: 10;
  animation: show 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

#great-static-lines {
  fill: none;
  opacity: 0.15;
  stroke: #BCAAA4;
  stroke-width: 12;
  stroke-miterlimit: 10;
  animation: show 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

#animated-lines {
  fill: none;
  opacity: 0.15;
  stroke: #fdac3e;
  stroke-width: 6;
  stroke-miterlimit: 10;
  stroke-dasharray: 200;
  stroke-dashoffset: 800;
  animation: draw 4s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes show {
  0% {
    opacity: 0.15;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.15;
  }
}
</style>
